import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AuthGuardService, LoggedInGuardService } from '@innobile/authmodule';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoggedInGuardService],
  },
  {
    path: '',
    canLoad: [AuthGuardService],
    canActivate: [AuthGuardService],
    data: { breadcrumb: null },
    loadChildren: () => import('./main/main.routes').then((m) => m.routes),
  },
];
